function objToString(obj: Object) {
    return obj ? JSON.stringify(obj) : obj;
}

export {
    objToString
}